import React, { useEffect, useState } from 'react';
import { NewHeader } from '../../components/shared/Header';
import ResponsiveAppBar from '../../components/shared/Menubar/ResponsiveAppBar';
import './ns.scss';
import { Input, Select } from '../../components/shared/InputSelet';
import {AppRoutes} from "../../Router";
import {Field, Form, Formik} from 'formik';
import * as Yup from "yup";
import { AdminService, AuthService, WLOCreditAPIService, AniConsultaError } from '../../services';
import { ANIPersona } from '../../context/RequestContext';
import toast from 'react-hot-toast';
import { cities } from '../../__mocks__/data';
import _ from "lodash";



export const NewUser = () => {
  const [profiles, setProfiles] = useState([]) as any;
  const [identificacion, setidentificacion] = useState([]) as any;
  const [cargo, setcargo] = useState([]) as any;
  const [oficina, setOficina] = useState([]) as any;
  const [enableManual, setEnableManual] = useState(false);
  const [ciudades2, setCiudades2] = useState(cities as any);
  const [allCities, setAllCiudades] = useState(cities as any);

  useEffect(()=>{
    AdminService.getAllCiudades().then((Datos: any) => {
            setAllCiudades(Datos.payload.data)
    })
    let citiesDepent2 = {
      "ListCiudad": {
        "Datos_Ciudad": [] as any
      }
    }          
    citiesDepent2.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' });           
    setCiudades2(citiesDepent2);
    getAlldata()
  },[])


  const getAlldata=async ()=>{
    const profiles= await AuthService.getPerfiles();
    if (profiles.payload.data.Array_Perfiles.Datos_Perfiles.length> 0) {    
      let Perfiles= profiles.payload.data.Array_Perfiles.Datos_Perfiles.map((item:any, key:any) => {
        return ({
            option:item.Pws_Tip_perfil,
            name:item.Pws_Nom_perf
          })
      })
      setProfiles(Perfiles)  
    }

    const tipoIdentificacion= await AdminService.gettipoidentificacion();
    if (tipoIdentificacion.payload.data.LstTiposIdent.Datos_TiposIdentificacion.length> 0) {    
      let identificacion= tipoIdentificacion.payload.data.LstTiposIdent.Datos_TiposIdentificacion.map((item:any, key:any) => {
        return ({
            option:item.s_codigo, 
            name:item.s_descripcion
          })
      })
      setidentificacion(identificacion)  
    }

    const cargo= await AdminService.getCargos();
    if (cargo.payload.data.ListCargos.Datos_Cargos.length> 0) {    
      let cargos= cargo.payload.data.ListCargos.Datos_Cargos.map((item:any, key:any) => {
        return ({
            option:item.s_codigo,
            name:item.s_descripcion
          })
      })
      setcargo(cargos)  
    } 
    
    const oficina= await AdminService.getOficinas();
    if (oficina.payload.data.ListOficina.Datos_Oficina.length> 0) {    
      let oficinas= oficina.payload.data.ListOficina.Datos_Oficina.map((item:any, key:any) => {
        return ({
            option:item.s_codigo,
            name:item.s_nombre
          })
      })
      setOficina(oficinas)  
    } 
  }


  const crearUsuario =async (values: any) => {
    console.log(values.Pws_Tip_identificacion);
    console.log(values.Pws_identificacion);
    
    try{
        if (enableManual) {
          let fechaFormateada = "";

        const [yyyy, mm, dd] = values.fechaExpedicion.split("-");
          fechaFormateada = `${mm}-${dd}-${yyyy}`;
        const personaRequest = {
          Pws_Identificacion: values.Pws_identificacion,
          Pws_Tip_Identificacion: values.Pws_Tip_identificacion,
          Pws_Tip_Estado: "2",
          Pws_Tip_Perfil: values.Pws_Tip_perfil,
          Pws_Tip_person: "N",
          Pws_Tip_ocupa: values.Pws_Tip_ocupa,
          Pws_Nombres: `${values.primerNombre} ${values.segundoNombre || ""}`.trim(),
          Pws_Apellidos1: values.primerApellido,
          Pws_Apellidos2: values.segundoApellido || "",
          Pws_Telefono1: values.Pws_telefono,
          Pws_Telefono2: "",
          Pws_Correo: values.Pws_email,
          Pws_Fec_expe: fechaFormateada,
          Pws_Lugar_exp: values.Pws_Lugar_exp,
          Pws_Fec_nacime: "",
          Pws_Estado_Civil: "",
          Pws_Direccion_res: "",
          Pws_Departamento: "",
          Pws_Ciudad_res: "",
          Pws_Genero: "",
          Pws_Estrato_per: "",
          Pws_Per_cargo: "",
          Pws_Tip_vivienda: "",
          Pws_Niv_estudio: "",
          Pws_Nom_empre: "",
          Pws_fec_ingemp: "",
          Pws_Fideliza: "",
          Pws_Tip_contra: "",
          Pws_Ant_labo: "",
          Pws_Car_emp: "",
          Pws_Nom_Jefedi: "",
          Pws_Direc_emp: "",
          Pws_Ciud_emp: "",
          Pws_tel_emp1: "",
          Pws_tel_emp2: "",
        };

        const result = await WLOCreditAPIService.addSolicitudPersona(personaRequest);
              // Crea usuario en Cygnus
              const cygnus=await WLOCreditAPIService.grabar_cignus({
                Pws_Identificacion: values.Pws_identificacion!,
                Pws_Tip_Identificacion:values.Pws_Tip_identificacion!,
                Pws_Tip_Perfil:values.Pws_Tip_perfil!
              })
              // Crea el usuario en la BD
              if(Number(cygnus.payload.result)>0){
                const createUser=await AuthService.createLogin({
                  Pws_Identificacion: values.Pws_identificacion!,
                  Pws_Tip_identificacion: values.Pws_Tip_identificacion!,
                  Pws_Tip_perfil: values.Pws_Tip_perfil!,
                  Pws_Tip_cargo: values.Pws_Tip_cargo,
                  Pws_clave_enc1: values.Pws_clave2,
                  Pws_clave_enc2: values.Pws_clave2,
                  Pws_Cod_oficina: values.Pws_Tip_oficina
                  ,
                })
                toast(createUser.payload.message)
              }else{
                  toast.error(cygnus.payload.MensajeError);
              }
      }else{
        const person = await WLOCreditAPIService.consultaSolicitudCygnus({
          Pws_Tip_Identificacion: values.Pws_Tip_identificacion!,
          Pws_Identificacion: values.Pws_identificacion!
        });
        console.log(person);
        if(person.payload.data.Resultado =="1"){
          if(person.payload.data &&  person.payload.data.datos_persona.Datos_persona[0]){
            person.payload.data.datos_persona.Datos_persona[0].Pws_Tip_Perfil = values.Pws_Tip_perfil
            const result = await WLOCreditAPIService.addSolicitudPersona(person.payload.data.datos_persona.Datos_persona[0]);
            
            // Crea usuario en Cygnus
            const cygnus=await WLOCreditAPIService.grabar_cignus({
              Pws_Identificacion: values.Pws_identificacion!,
              Pws_Tip_Identificacion:values.Pws_Tip_identificacion!,
              Pws_Tip_Perfil:values.Pws_Tip_perfil!
          })
            // Crea el usuario en la BD
            if(Number(cygnus.payload.result)>0){
              const createUser=await AuthService.createLogin({
                Pws_Identificacion: values.Pws_identificacion!,
                Pws_Tip_identificacion: values.Pws_Tip_identificacion!,
                Pws_Tip_perfil: values.Pws_Tip_perfil!,
                Pws_Tip_cargo: values.Pws_Tip_cargo,
                Pws_clave_enc1: values.Pws_clave2,
                Pws_clave_enc2: values.Pws_clave2,
                Pws_Cod_oficina: values.Pws_Tip_oficina
                ,
              })
              toast(createUser.payload.message)
            }else{
                toast.error(cygnus.payload.MensajeError);
            }
          }
        }else{
          let personANI;
          try{
              personANI = await WLOCreditAPIService.consultaSolicitudANI({
                Pws_Tip_Identificacion: values.Pws_Tip_identificacion!,
                Pws_Identificacion: values.Pws_identificacion!
              });
              const pANI = personANI as ANIPersona;
              const fecha = personANI.fechaExpedicion.split('/');

              // Crea usuario en WLO
              const personaRequest = {
                Pws_Identificacion: values.Pws_identificacion,
                Pws_Tip_Identificacion: values.Pws_Tip_identificacion,
                Pws_Tip_Estado: "2", // Valor constante para confirmación de información.
                Pws_Tip_Perfil: values.Pws_Tip_perfil,
                Pws_Tip_person: "N",
                Pws_Tip_ocupa: values.Pws_Tip_ocupa,
                Pws_Nombres: pANI.primerNombre+" "+pANI.segundoNombre,
                Pws_Apellidos1: pANI.primerApellido,
                Pws_Apellidos2: pANI.segundoApellido,
                Pws_Telefono1: values.Pws_telefono,
                Pws_Telefono2: "",
                Pws_Correo: values.Pws_email,
                Pws_Fec_expe: fecha[2]+'-'+fecha[1]+'-'+fecha[0],
                Pws_Lugar_exp: pANI.municipioExpedicion,
                Pws_Fec_nacime: "",
                Pws_Estado_Civil: "",
                Pws_Direccion_res: "",
                Pws_Departamento: "",
                Pws_Ciudad_res: "",
                Pws_Genero: "",
                Pws_Estrato_per: "",
                Pws_Per_cargo: "",
                Pws_Tip_vivienda: "",
                Pws_Niv_estudio: "",
                Pws_Nom_empre: "",
                Pws_fec_ingemp: "",
                Pws_Fideliza: "",
                Pws_Tip_contra: "",
                Pws_Ant_labo: "",
                Pws_Car_emp: "",
                Pws_Nom_Jefedi: "",
                Pws_Direc_emp: "",
                Pws_Ciud_emp: "",
                Pws_tel_emp1: "",
                Pws_tel_emp2: "",
              }
              const result = await WLOCreditAPIService.addSolicitudPersona(personaRequest);
              // Crea usuario en Cygnus
              const cygnus=await WLOCreditAPIService.grabar_cignus({
                Pws_Identificacion: values.Pws_identificacion!,
                Pws_Tip_Identificacion:values.Pws_Tip_identificacion!,
                Pws_Tip_Perfil:values.Pws_Tip_perfil!
              })
              // Crea el usuario en la BD
              if(Number(cygnus.payload.result)>0){
                const createUser=await AuthService.createLogin({
                  Pws_Identificacion: values.Pws_identificacion!,
                  Pws_Tip_identificacion: values.Pws_Tip_identificacion!,
                  Pws_Tip_perfil: values.Pws_Tip_perfil!,
                  Pws_Tip_cargo: values.Pws_Tip_cargo,
                  Pws_clave_enc1: values.Pws_clave2,
                  Pws_clave_enc2: values.Pws_clave2,
                  Pws_Cod_oficina: values.Pws_Tip_oficina
                  ,
                })
                toast(createUser.payload.message)
              }else{
                  toast.error(cygnus.payload.MensajeError);
              }
          }catch(e){
            setEnableManual(true);
            if (!(e instanceof AniConsultaError)) {
              toast.error("Debe ingresar manualmente la informacion de la persona")
            }
            return;
          }
        }}
      }catch(e){
        console.log(e);
        toast.error('error'+e)
        
      }
    
  }


  

const validationSchema = Yup.object().shape({
        Pws_Tip_perfil: Yup.string().required('(*)'),
        Pws_Tip_oficina: Yup.string().required('(*)'),
        Pws_Tip_identificacion: Yup.string().required('(*)'),
        Pws_identificacion: Yup.string().required('(*)'),
        Pws_email: Yup.string().email("Correo electronico Invalido").required('(*)'),
        Pws_telefono: Yup.number().min(8).required('(*)'),
        Pws_Tip_cargo: Yup.string().required('(*)'),
        Pws_clave: Yup.string().required('(*)').min(8, "Minimo 8 caracteres").required('(*)'),
        Pws_clave2: Yup.string().required('(*)').oneOf([Yup.ref('Pws_clave'),null],"La contraseña no coincide"),
        primerNombre: Yup.string().when([], {
          is: () => enableManual === true,
          then: s => s.required("(*)"),
        }),
        primerApellido: Yup.string().when([], {
          is: () => enableManual === true,
          then: s => s.required("(*)"),
        }),
        fechaExpedicion: Yup.date().when([], {
          is: () => enableManual === true,
          then: s => s.required("(*)"),
        }),
        Pws_Lugar_exp: Yup.string().when([], {
          is: () => enableManual === true,
          then: s => s.required("(*)"),
        })
      })
  return (
    <>
      <ResponsiveAppBar/>
      <Formik
        initialValues={{
          Pws_Tip_perfil: '',
          Pws_Tip_oficina: '',
          Pws_Tip_identificacion: '',
          Pws_identificacion: '',
          Pws_email: '',
          Pws_telefono: '',
          Pws_Tip_cargo: '',
          Pws_clave: '',
          Pws_clave2: '',
          primerNombre: '',
          segundoNombre: '',
          primerApellido: '',
          segundoApellido: '',
          fechaExpedicion: '',
          Pws_Lugar_exp: '',
        }}
        validationSchema={validationSchema}
        onSubmit={crearUsuario}
      >
        {({errors, isSubmitting}) =>{   
          return (
            <>
              <Form>
                <NewHeader next={`block`} backReturn={AppRoutes.USUARIOS_PLATAFORM}/>
                        
                <div className='New-User'>
                  <div className="left-side">
                    <h4 className='redhead'>Nuevo usuario</h4>
                    <p className='subHead'>Ingresa los datos del nuevo usuario y verifica la información</p>

                    <ul>
                      <Select dir={`goDown`} label={`Perfil del usuario: `} name={`Pws_Tip_perfil`} options={profiles} errors={errors} />
                      <Select dir={`goDown`} label={`Código oficina: `} name={`Pws_Tip_oficina`} options={oficina}  errors={errors}/>
                    </ul>
                    <ul>
                      <Select dir={`goDown`} label={`Tipo de identificación`} name={`Pws_Tip_identificacion`} options={identificacion}  errors={errors}/>
                      <Input type={`text`} dir={`goDown`} label={`Identificación`} name={`Pws_identificacion`} placeholder={`Identificación`}errors={errors} />
                    </ul>
                    <ul>
                    <Input type={`text`} dir={`goDown`} label={`Correo`} name={`Pws_email`} placeholder={`Correo`}errors={errors} />
                      <Input type={`text`} dir={`goDown`} label={`Telefono`} name={`Pws_telefono`} placeholder={`Telefono`}errors={errors} />
                    </ul>
                    {enableManual && (
                      <ul>
                        <Input type="text" dir="goDown" label="Primer Nombre" name="primerNombre" placeholder="Primer Nombre" errors={errors}/>
                        <Input type="text" dir="goDown" label="Segundo Nombre" name="segundoNombre" placeholder="Segundo Nombre (Opcional)" errors={errors}/>
                      </ul>
                    )}

                    {enableManual && (
                      <ul>
                        <Input type="text" dir="goDown" label="Primer Apellido" name="primerApellido" placeholder="Primer Apellido" errors={errors}/>
                        <Input type="text" dir="goDown" label="Segundo Apellido" name="segundoApellido" placeholder="Segundo Apellido (Opcional)" errors={errors}/>
                      </ul>
                    )}

                    {enableManual && (
                      <ul>
                        <Input
                          type="date"
                          dir="goDown"
                          label="Fecha expedición (MM-DD-YYYY)"
                          name="fechaExpedicion"
                          placeholder="Mes-Día-Año"
                          errors={errors}
                        />
                        <Field as="select" name="Pws_Lugar_exp">
                          <option value="">Lugar de Expedición</option>
                          {ciudades2 && ciudades2.ListCiudad.Datos_Ciudad.map((item: any, key: number) => (
                            <option key={key} value={item.s_codigo}>
                              {item.s_nombre}
                            </option>
                          ))}
                        </Field>
                        {errors.Pws_Lugar_exp && (
                          <div className="error-message">(*) {errors.Pws_Lugar_exp}</div>
                        )}
                      </ul>
                    )}

                    <ul>
                      <Select dir={`goDown`} label={`Cargo`} name={`Pws_Tip_cargo`} options={cargo}  errors={errors}/>
                    </ul>
                    <ul>
                      <Input type={`password`} dir={`goDown`} label={`Contraseña`} name={`Pws_clave`} placeholder={`Contraseña`} errors={errors} />
                      <Input type={`password`} dir={`goDown`} label={`Repetir contraseña`} name={`Pws_clave2`} placeholder={`Repetir contraseña`} errors={errors}/>
                    </ul>
                  </div>
                  <div className="right-side">
                    <img src="img/Hombre.png" alt="Hombre" />
                  </div>
                </div>
              </Form>
            </>
          )                   
        }}
      </Formik>
    </>
  )
}
